module.exports = __webpack_public_path__ + "img/body-background-textura01.77461750.svg";